export default "__VITE_ASSET__BKYZHZGm__"